"use strict";
import {createSwiper} from "./swiper";
import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from '@elements/dom-utils';

export function init () {

    onFind('.js-hero-slider', function (sliderElement) {
        createSwiper(sliderElement,{
                loop: true,
                slidesPerView: 1,
                navigation: {
                    findNextElement: swiperContainer => findIn('.js-hero-slider__next', swiperContainer),
                    findPrevElement: swiperContainer => findIn('.js-hero-slider__prev', swiperContainer),
                },
                pagination: {
                    el: swiperContainer => findIn('.js-hero-slider__pagination', swiperContainer),
                    clickable: true
                }
            },
            {
                sliderContainer: '.js-hero-slider',
                slider: '.js-hero-slider__slider'
            });

    });
}

